<div class="p-6 max-w-3xl mx-auto">

  <!-- Header -->
  <div class="mb-5">
    <nav class="flex items-center gap-1.5 text-xs text-gray-400 mb-2">
      <a routerLink="/automation/workflows" class="hover:text-blue-600">Workflows</a>
      <span>/</span>
      <a routerLink="/automation/workflow-actions/test" class="hover:text-blue-600">Probar Acciones</a>
      <span>/</span>
      <span class="text-gray-600">Actividades RF-08</span>
    </nav>
    <div class="flex items-center gap-2 mb-1">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Probar Acciones de Actividad</h1>
      <span class="px-2 py-0.5 text-xs bg-teal-100 text-teal-700 rounded-full font-medium">RF-08</span>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Prueba la creación de tareas, notas, completado de tareas y programación de reuniones sin ejecutar un workflow completo.
    </p>
  </div>

  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''" class="ml-2 shrink-0">&times;</button>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración</h2>
      <div class="space-y-3">

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de acción *</label>
          <select [(ngModel)]="actionType" (ngModelChange)="result = null; error = ''"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
            @for (opt of actionTypeOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
            }
          </select>
        </div>

        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
            <select [(ngModel)]="objectType" (ngModelChange)="onObjectTypeChange()"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
              @for (ot of objectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro (opcional)</label>
            @if (recordSelect.isSearchable()) {
              <app-entity-select
                [value]="objectId"
                (valueChange)="objectId = $event"
                (selected)="onRecordSelected($event)"
                [displayText]="recordDisplayText"
                [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
                placeholder="Buscar por nombre…"></app-entity-select>
            } @else {
              <input type="number" [(ngModel)]="objectId" placeholder="Ej: 42"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
            }
          </div>
        </div>

        <!-- CREATE_TASK -->
        @if (isCreateTask) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Título *</label>
            <input [(ngModel)]="taskTitle" placeholder="Ej: Llamar a {{ '{{' }}contact.firstname{{ '}}' }}"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
            <textarea [(ngModel)]="taskDescription" rows="2"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"></textarea>
          </div>
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo</label>
              <select [(ngModel)]="taskType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
                @for (t of taskTypeOptions; track t.value) { <option [value]="t.value">{{ t.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Prioridad</label>
              <select [(ngModel)]="taskPriority" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
                @for (p of priorityOptions; track p.value) { <option [value]="p.value">{{ p.label }}</option> }
              </select>
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Vencimiento (relativo)</label>
            <div class="flex items-center gap-2">
              <input type="number" [(ngModel)]="taskDueAmount" min="0" placeholder="1"
                     class="w-20 px-2 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
              <select [(ngModel)]="taskDueUnit" class="flex-1 px-2 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
                @for (u of dueUnitOptions; track u.value) { <option [value]="u.value">{{ u.label }}</option> }
              </select>
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Asignado a</label>
            <select [(ngModel)]="taskAssigneeType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
              <option value="OWNER">Responsable del registro</option>
              <option value="SPECIFIC_USER">Usuario específico</option>
            </select>
            @if (taskAssigneeType === 'SPECIFIC_USER') {
              <div class="mt-1.5">
                <app-entity-select
                  [value]="taskAssigneeUserId"
                  [displayText]="userNameById(taskAssigneeUserId)"
                  (valueChange)="taskAssigneeUserId = $event"
                  [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
                  placeholder="Buscar usuario…"></app-entity-select>
              </div>
            }
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Notas</label>
            <input [(ngModel)]="taskNotes" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
          </div>
          <div class="flex flex-wrap gap-4">
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="taskAssociate" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Asociar al registro actual</span>
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="taskContinueOnError" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
            </label>
          </div>
        }

        <!-- CREATE_NOTE -->
        @if (isCreateNote) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Texto de la nota *</label>
            <textarea [(ngModel)]="noteText" rows="3"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"></textarea>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Visibilidad</label>
            <select [(ngModel)]="noteVisibility" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
              @for (v of visibilityOptions; track v.value) { <option [value]="v.value">{{ v.label }}</option> }
            </select>
          </div>
          <div class="flex flex-wrap gap-4">
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="noteAssociate" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Asociar al registro actual</span>
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="noteContinueOnError" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
            </label>
          </div>
        }

        <!-- COMPLETE_TASK -->
        @if (isCompleteTask) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">¿Qué tarea completar?</label>
            <select [(ngModel)]="completeSelectorType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
              @for (s of completeSelectorOptions; track s.value) { <option [value]="s.value">{{ s.label }}</option> }
            </select>
          </div>
          @if (completeSelectorType === 'EXPLICIT') {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tarea *</label>
              <app-entity-select
                [value]="completeTaskId"
                [displayText]="completeTaskName"
                (valueChange)="completeTaskId = $event"
                (selected)="onCompleteTaskSelected($event)"
                [searchFn]="taskSearch" [labelFn]="taskLabel" [sublabelFn]="taskSublabel"
                placeholder="Buscar tarea por título…"></app-entity-select>
            </div>
          }
          @if (completeSelectorType === 'TITLE_CONTAINS') {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">El título contiene *</label>
              <input [(ngModel)]="completeTitleContains" placeholder="Ej: Seguimiento"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
            </div>
          }
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Filtrar por tipo (opcional)</label>
            <select [(ngModel)]="completeTaskType" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
              <option value="">Cualquier tipo</option>
              @for (t of taskTypeOptions; track t.value) { <option [value]="t.value">{{ t.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Nota de completado</label>
            <input [(ngModel)]="completionNote" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
          </div>
          <label class="flex items-center gap-1.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="completeContinueOnError" class="w-3.5 h-3.5 rounded text-teal-600"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
          </label>
        }

        <!-- SCHEDULE_MEETING -->
        @if (isScheduleMeeting) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Título *</label>
            <input [(ngModel)]="meetingTitle" class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
            <textarea [(ngModel)]="meetingDescription" rows="2"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"></textarea>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Inicio (relativo)</label>
            <div class="flex items-center gap-2">
              <input type="number" [(ngModel)]="meetingStartAmount" min="0"
                     class="w-16 px-2 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
              <select [(ngModel)]="meetingStartUnit" class="flex-1 px-2 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500">
                @for (u of dueUnitOptions; track u.value) { <option [value]="u.value">{{ u.label }}</option> }
              </select>
              <input [(ngModel)]="meetingStartTime" placeholder="10:00"
                     class="w-20 px-2 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Zona horaria</label>
              <input [(ngModel)]="meetingTimezone" placeholder="America/Lima"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Duración (min)</label>
              <input type="number" [(ngModel)]="meetingDuration" min="5"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
            </div>
          </div>
          <div>
            <label class="flex items-center gap-1.5 cursor-pointer mb-1.5">
              <input type="checkbox" [(ngModel)]="meetingOwnerAsOrganizer" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">El responsable es el organizador</span>
            </label>
            @if (!meetingOwnerAsOrganizer) {
              <app-entity-select
                [value]="meetingOrganizerUserId"
                [displayText]="userNameById(meetingOrganizerUserId)"
                (valueChange)="meetingOrganizerUserId = $event"
                [searchFn]="userSearch" [labelFn]="userLabel" [sublabelFn]="userSublabel"
                placeholder="Buscar organizador…"></app-entity-select>
            }
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Propiedad email del asistente</label>
            <input [(ngModel)]="meetingEmailProperty" placeholder="email"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500"/>
          </div>
          <div class="flex flex-wrap gap-4">
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="meetingAssociate" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Asociar al registro</span>
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="meetingCreateCalendarEvent" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Crear evento de calendario</span>
            </label>
            <label class="flex items-center gap-1.5 cursor-pointer">
              <input type="checkbox" [(ngModel)]="meetingContinueOnError" class="w-3.5 h-3.5 rounded text-teal-600"/>
              <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si error</span>
            </label>
          </div>
        }

        <!-- Contexto de prueba (opcional) -->
        <div class="border-t border-gray-100 dark:border-gray-700 pt-3">
          <button type="button" (click)="showContext = !showContext"
                  class="flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
            <svg class="w-3.5 h-3.5 transition-transform" [class.rotate-90]="showContext" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
            Datos de contexto para tokens (opcional)
          </button>
          @if (showContext) {
            <textarea [(ngModel)]="contextJson" rows="4" placeholder='{ "contact": { "firstname": "Juan", "email": "juan@test.com" } }'
                      class="mt-2 w-full px-3 py-2 text-xs font-mono border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"></textarea>
            <p class="text-[11px] text-gray-400 mt-1">Se usa para sustituir tokens como {{ '{{' }}contact.firstname{{ '}}' }} durante la prueba.</p>
          }
        </div>

        <button (click)="test()" [disabled]="loading"
                class="w-full py-2 text-sm rounded-lg disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2 bg-teal-600 text-white hover:bg-teal-700">
          @if (loading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Ejecutando...
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3l14 9-14 9V3z"/>
            </svg>
            Probar acción
          }
        </button>
      </div>
    </div>

    <!-- Resultado -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

      @if (!result && !loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
          <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
          <p class="text-sm">Ejecuta una acción de actividad para ver el resultado</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-400">
          <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p class="text-sm">Ejecutando acción de actividad...</p>
        </div>
      }

      @if (result && !loading) {
        <!-- Status badge -->
        <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
             [ngClass]="result.status === 'SUCCESS' ? 'bg-green-50 dark:bg-green-900/20' : result.status === 'SKIPPED' ? 'bg-gray-50 dark:bg-gray-700/40' : 'bg-red-50 dark:bg-red-900/20'">
          <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="getStatusClass(result.status)">
            {{ statusLabel(result.status) }}
          </span>
          <p class="text-sm text-gray-700 dark:text-gray-300">{{ result.message }}</p>
        </div>

        <!-- Key details -->
        <dl class="space-y-2 text-sm mb-4">
          @if (result.actionType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Tipo de acción</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white">{{ actionTypeLabel(result.actionType) }}</dd>
            </div>
          }
          @if (result.targetObjectType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Objeto afectado</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white" [title]="result.targetObjectType || ''">
                {{ recordText(result.targetObjectType, result.targetObjectId) }}
              </dd>
            </div>
          }
        </dl>

        <!-- CREATE_TASK result details -->
        @if (isCreateTask && result.output) {
          <div class="mb-3 p-3 bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-teal-700 dark:text-teal-400">Tarea creada</p>
            @if (result.output['taskId']) {
              <p class="text-teal-600">ID: <span class="font-mono font-medium">{{ result.output['taskId'] }}</span></p>
            }
            @if (result.output['title']) {
              <p class="text-teal-600">Titulo: {{ result.output['title'] }}</p>
            }
            @if (result.output['assignedTo']) {
              <p class="text-teal-600">Asignado a: {{ userNameById(result.output['assignedTo']) }}</p>
            }
            @if (result.output['dueDate']) {
              <p class="text-teal-600">Vence: {{ result.output['dueDate'] }}</p>
            }
          </div>
        }

        <!-- CREATE_NOTE result details -->
        @if (isCreateNote && result.output) {
          <div class="mb-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-xs">
            <p class="font-semibold text-blue-700 dark:text-blue-400">Nota registrada en historial</p>
          </div>
        }

        <!-- COMPLETE_TASK result details -->
        @if (isCompleteTask && result.output) {
          <div class="mb-3 p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-green-700 dark:text-green-400">Tarea completada</p>
            @if (result.output['taskId']) {
              <p class="text-green-600">ID: <span class="font-mono font-medium">{{ result.output['taskId'] }}</span></p>
            }
          </div>
        }

        <!-- SCHEDULE_MEETING result details -->
        @if (isScheduleMeeting && result.output) {
          <div class="mb-3 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-indigo-700 dark:text-indigo-400">Reunión programada</p>
            @if (result.output['meetingId']) {
              <p class="text-indigo-600">ID: <span class="font-mono font-medium">{{ result.output['meetingId'] }}</span></p>
            }
            <p class="text-indigo-600">Calendario externo:
              <span class="font-medium">{{ result.output['calendarEventStatus'] ? statusLabel(result.output['calendarEventStatus']) : 'No solicitado' }}</span>
            </p>
          </div>
        }

        <!-- Output JSON -->
        @if (result.output && (result.output | json) !== '{}') {
          <div class="mb-3">
            <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Resultado (JSON)</p>
            <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 max-h-40 whitespace-pre-wrap">{{ resultJson }}</pre>
          </div>
        }

        <!-- Error JSON -->
        @if (result.error && (result.error | json) !== '{}') {
          <div class="mb-3">
            <p class="text-xs font-semibold text-red-500 uppercase tracking-wide mb-1">Error</p>
            <pre class="text-xs font-mono bg-red-50 dark:bg-red-900/20 p-3 rounded-lg overflow-x-auto text-red-800 dark:text-red-300 max-h-32 whitespace-pre-wrap">{{ errorJson }}</pre>
          </div>
        }

        <!-- Warnings -->
        @if (result.warnings?.length) {
          <div class="p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700">
            @for (w of result.warnings!; track w) { <p>⚠ {{ w }}</p> }
          </div>
        }
      }
    </div>
  </div>

  <!-- Info note -->
  <div class="mt-4 p-3 bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-800 rounded-lg text-xs text-teal-700 dark:text-teal-300">
    <p class="font-semibold mb-1">Acciones disponibles en RF-08 (Actividades):</p>
    <div class="flex flex-wrap gap-1.5 mt-1">
      @for (opt of actionTypeOptions; track opt.value) {
        <span class="px-1.5 py-0.5 bg-teal-100 dark:bg-teal-900/30 rounded text-[10px]">{{ opt.label }}</span>
      }
    </div>
    <p class="mt-2 text-teal-500">En "Programar reunión", el evento del calendario externo queda sin crear hasta que esa integración esté activa; la reunión sí se guarda en el CRM.</p>
  </div>

  <!-- Navigation links -->
  <div class="mt-4 flex flex-wrap gap-2">
    <a routerLink="/automation/workflow-actions/test"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
      Probar Acciones
    </a>
    <a routerLink="/automation/workflow-actions/crm-test"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-indigo-200 dark:border-indigo-800 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors">
      Acciones CRM (RF-07)
    </a>
  </div>
</div>
